/**
 * @generated SignedSource<<0554659cc5fd34befba0311788820281>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsForm_recipient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationSetting",
      "kind": "LinkedField",
      "name": "notificationSettings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NotificationCycle",
          "kind": "LinkedField",
          "name": "cycle",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NotificationCategory",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NotificationRecipient",
  "abstractKey": "__isNotificationRecipient"
};
})();

node.hash = "0c7ca318335d79429bc8606a5fca194f";

module.exports = node;
